/* =====================================================================
   Maison Stiletto (V5) : pages collection et recherche (sections mp-collection, mp-search, snippet mp-filters)
   Charge en defer par sections/mp-global.liquid apres mp-base.js (window.MP).
   - Filtres : tout changement du formulaire GET met a jour la section par la Section Rendering API (MP.section),
     sans recharger, puis history.replaceState. Erreur reseau = navigation classique vers la meme URL.
   - Tri : le select de la barre (>= 990 px) pilote les boutons radio du formulaire (seule source de verite).
   - Tiroir de filtres (< 1200 px) : MP.layer, panneau deplace dans body pendant l'ouverture (voile et z-index surs).
   - Colonne de filtres (>= 1200 px) : "Hide filters" (choix garde dans localStorage, simple confort).
   - "Load more" ajoute la page suivante a la grille ; "View previous items" la page d'avant (retour sur ?page=3).
   - Puces de categories (ligne qui defile) : la puce active est ramenee au centre de la ligne au chargement.
   Sans JS : formulaires GET, liens, :target. Les morceaux remplaces portent data-mp-part (voir snippets/mp-filters).
   ===================================================================== */
(function () {
  'use strict';

  var doc = document;
  var STORE_KEY = 'mp-filters-hidden';
  var WIDE = window.matchMedia ? window.matchMedia('(min-width: 1200px)') : { matches: false };

  /* ---------- Textes : bloc <script data-mp-i18n="collection"> rendu par snippets/mp-filters (lu par MP.t), repli anglais ---------- */
  var FALLBACK = {
    show_more: 'Show more ([n])',
    show_less: 'Show less',
    items_added_one: '1 item added.',
    items_added_other: '[n] items added.'
  };
  // tr('show_more', { n: 4 }) : texte de la langue courante, [n] remplace par la valeur
  function tr(key, vars) {
    var fb = FALLBACK[key] || '';
    if (window.MP && typeof window.MP.t === 'function') return window.MP.t('collection', key, fb, vars);
    var s = fb;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('[' + k + ']').join(String(vars[k])); });
    return s;
  }

  function $(root, sel) { return root ? root.querySelector(sel) : null; }
  function $$(root, sel) { return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : []; }
  function raf(fn) {
    if (doc.hidden || !window.requestAnimationFrame) return setTimeout(fn, 16);
    return window.requestAnimationFrame(fn);
  }
  function onMq(mq, fn) {
    if (!mq) return;
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }
  function offMq(mq, fn) {
    if (!mq) return;
    if (mq.removeEventListener) mq.removeEventListener('change', fn);
    else if (mq.removeListener) mq.removeListener(fn);
  }
  function reduce() { return !!(window.MP && MP.mq && MP.mq.reduce && MP.mq.reduce.matches); }
  function focusNoScroll(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function readHidden() {
    try { return window.localStorage.getItem(STORE_KEY) === '1'; } catch (e) { return false; }
  }
  function saveHidden(on) {
    try {
      if (on) window.localStorage.setItem(STORE_KEY, '1');
      else window.localStorage.removeItem(STORE_KEY);
    } catch (e) { /* stockage indisponible : sans importance */ }
  }
  function headerOffset() {
    var v = parseFloat(window.getComputedStyle(doc.documentElement).getPropertyValue('--mp-header-offset'));
    return isNaN(v) ? 0 : v;
  }
  // URL affichee : sans le parametre technique de la Section Rendering API
  function cleanUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('sections');
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }
  function plainClick(e) {
    return !(e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
  }

  function setup(root) {
    if (!root || root.__mpCol || !window.MP || !MP.section) return;

    var sid = root.getAttribute('data-section-id');
    var defaultSort = root.getAttribute('data-default-sort') || '';
    var panel = $(root, '[data-mp-filters-panel]');
    var bar = $(root, '[data-mp-filters-bar]');
    var sentinel = $(root, '[data-mp-filters-sentinel]');
    var home = null;
    var seq = 0;
    var timer = null;
    var backTimer = null;
    var applied = cleanUrl(window.location.href);
    var stuckPending = false;

    if (panel) {
      // repere pour remettre le panneau a sa place (colonne >= 1200 px) apres l'ouverture en tiroir
      home = doc.createComment('mp-filters');
      panel.parentNode.insertBefore(home, panel);
      // ouvert par :target (lien suivi avant le chargement du JS) : on nettoie l'ancre
      if (window.location.hash === '#' + panel.id) {
        try { history.replaceState(history.state, '', window.location.pathname + window.location.search); } catch (e) {}
      }
    }

    function form() { return panel ? $(panel, '[data-mp-filters-form]') : null; }
    function part(name) {
      var sel = '[data-mp-part="' + name + '"]';
      return $(root, sel) || $(panel, sel);
    }
    function isSidebar() { return WIDE.matches && root.classList.contains('mp-collection--side'); }
    function drawerOpen() { return !!(panel && MP.layer && MP.layer.isOpen(panel)); }

    /* ---------- URL depuis le formulaire ---------- */
    function urlFromForm() {
      var f = form();
      var base = (f && f.getAttribute('action')) || window.location.pathname;
      var u = new URL(base, window.location.origin);
      var params = new URLSearchParams();
      if (f && window.FormData) {
        new FormData(f).forEach(function (v, k) {
          if (typeof v !== 'string') return;
          v = v.trim();
          if (!v) return; // prix vides
          if (k === 'sort_by' && v === defaultSort) return; // tri par defaut : URL propre
          params.append(k, v);
        });
      }
      u.search = params.toString();
      return u.pathname + u.search;
    }

    /* ---------- Remplacement des morceaux ---------- */
    function swapNode(name, fresh) {
      var next = fresh.querySelector('[data-mp-part="' + name + '"]');
      var cur = part(name);
      if (!next || !cur || !cur.parentNode) return null;
      var node = doc.importNode(next, true);
      cur.parentNode.replaceChild(node, cur);
      return node;
    }
    // corps du panneau : on garde les groupes ouverts, les listes depliees, le defilement et le focus
    function swapPanelBody(fresh) {
      var cur = part('panel-body');
      var next = fresh.querySelector('[data-mp-part="panel-body"]');
      if (!cur || !next) return;
      var open = {};
      var expanded = {};
      $$(cur, 'details[id]').forEach(function (d) { open[d.id] = d.open; });
      $$(cur, '[data-mp-filters-group].is-expanded').forEach(function (g) { expanded[g.id] = true; });
      var active = doc.activeElement;
      var activeId = active && cur.contains(active) ? active.id : '';
      var top = cur.scrollTop;
      var node = doc.importNode(next, true);
      $$(node, 'details[id]').forEach(function (d) {
        if (Object.prototype.hasOwnProperty.call(open, d.id)) d.open = open[d.id];
      });
      cur.parentNode.replaceChild(node, cur);
      initMore(node, expanded);
      node.scrollTop = top;
      if (activeId) focusNoScroll(doc.getElementById(activeId));
    }
    function syncSort(fresh) {
      var sel = part('bar-sort');
      var nsel = fresh.querySelector('[data-mp-part="bar-sort"]');
      if (sel && nsel) sel.value = nsel.value;
      var lab = part('bar-sort-label');
      var nlab = fresh.querySelector('[data-mp-part="bar-sort-label"]');
      if (lab && nlab) lab.textContent = nlab.textContent;
    }
    function countLabel() {
      var c = part('bar-count');
      return c ? (c.getAttribute('data-count-label') || c.textContent || '') : '';
    }
    function swap(fresh) {
      ['bar-count', 'bar-badge', 'sort-hidden', 'results', 'panel-foot'].forEach(function (n) { swapNode(n, fresh); });
      swapPanelBody(fresh);
      syncSort(fresh);
      // compteurs hors section (en-tete compact de la collection, titre de la recherche)
      var label = countLabel();
      $$(doc, '[data-mp-collection-count]').forEach(function (el) { el.textContent = label; });
    }

    /* ---------- Rendu d'une URL de la collection ---------- */
    // V1.13 : en apercu d'un theme non publie, la requete doit porter preview_theme_id (sinon Shopify rend le theme en ligne)
    function withPreview(url) {
      var t = window.Shopify && window.Shopify.theme;
      if (!t || !t.id || t.role === 'main') return url;
      var u = new URL(url, window.location.origin);
      u.searchParams.set('preview_theme_id', t.id);
      return u.pathname + u.search;
    }
    // section seule (rapide) ; si elle echoue, la page complete, dont on extrait la section
    function fetchFresh(url) {
      return MP.section(sid, withPreview(url))
        .then(function (d) {
          var fresh = d.querySelector('[data-mp-collection]');
          if (!fresh) throw new Error('section');
          return fresh;
        })
        .catch(function () {
          return fetch(withPreview(url), { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
            .then(function (html) {
              var d = new DOMParser().parseFromString(html, 'text/html');
              var fresh = d.querySelector('[data-mp-collection][data-section-id="' + sid + '"]') || d.querySelector('[data-mp-collection]');
              if (!fresh) throw new Error('page');
              return fresh;
            });
        });
    }

    /* ---------- Mise a jour ---------- */
    function toResults() {
      if (drawerOpen()) return;
      var r = part('results');
      if (!r) return;
      var barH = bar ? bar.offsetHeight : 0;
      var y = r.getBoundingClientRect().top + window.pageYOffset - headerOffset() - barH - 8;
      // on remonte seulement si la grille est passee au-dessus de l'ecran
      if (window.pageYOffset > y + 4) window.scrollTo({ top: Math.max(0, y), behavior: reduce() ? 'auto' : 'smooth' });
    }
    function update(url, opts) {
      opts = opts || {};
      clearTimeout(timer);
      timer = null;
      url = cleanUrl(url);
      applied = url;
      var token = ++seq;
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');
      return fetchFresh(url)
        .then(function (fresh) {
          if (token !== seq) return;
          swap(fresh);
          try { history.replaceState(history.state, '', url); } catch (e) {}
          if (MP.init) {
            MP.init(root);
            if (panel && !root.contains(panel)) MP.init(panel);
          }
          MP.announce(countLabel().replace(/\u00a0/g, ' '));
          if (opts.scroll) toResults();
        })
        .catch(function () {
          if (token !== seq) return;
          window.location.href = url;
        })
        .then(function () {
          if (token !== seq) return;
          root.classList.remove('is-loading');
          root.removeAttribute('aria-busy');
        });
    }
    function schedule(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        var url = urlFromForm();
        if (url !== applied) update(url, { scroll: isSidebar() });
      }, delay);
    }

    /* ---------- Pages suivante / precedente ---------- */
    // V1.13 (demande de Florian) : tous les produits a la suite sur la meme page, jamais de passage a une page 2 ;
    // l'URL reste celle de la collection, un echec de chargement est retente au lieu d'ouvrir la page suivante
    var failures = 0;
    function loadPage(link, dir) {
      if (link.getAttribute('aria-busy') === 'true') return;
      var url = cleanUrl(link.href);
      var hadFocus = doc.activeElement === link;
      link.setAttribute('aria-busy', 'true');
      link.classList.add('is-loading');
      fetchFresh(url)
        .then(function (fresh) {
          failures = 0;
          var nextGrid = fresh && fresh.querySelector('[data-mp-collection-grid]');
          var grid = $(root, '[data-mp-collection-grid]');
          if (!nextGrid || !grid) throw new Error('grille');
          // sans doublon : si la collection a bouge entre deux chargements, un produit deja affiche n'est pas repete
          var cardUrl = function (li) {
            var a = li.querySelector && li.querySelector('a[href*="/products/"]');
            return a ? a.getAttribute('href').split('?')[0] : '';
          };
          var shownUrls = {};
          Array.prototype.forEach.call(grid.children, function (li) { shownUrls[cardUrl(li)] = true; });
          var items = Array.prototype.slice.call(nextGrid.children)
            .filter(function (n) { var u = cardUrl(n); return !u || !shownUrls[u]; })
            .map(function (n) { return doc.importNode(n, true); });
          var frag = doc.createDocumentFragment();
          items.forEach(function (i) { frag.appendChild(i); });
          if (dir === 'prev') {
            grid.insertBefore(frag, grid.firstChild);
            swapNode('prev', fresh);
          } else {
            grid.appendChild(frag);
            swapNode('more', fresh);
          }
          var first = items[0];
          var a = first && first.querySelector('a[href]');
          if (dir === 'prev' && first) {
            var barH = bar ? bar.offsetHeight : 0;
            var y = first.getBoundingClientRect().top + window.pageYOffset - headerOffset() - barH - 16;
            window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
          }
          if (hadFocus && a) focusNoScroll(a);
          var more = part('more');
          var txt = more && $(more, '.mp-filters__progress-txt');
          var added = items.length === 1 ? tr('items_added_one') : tr('items_added_other', { n: items.length });
          MP.announce(added + (txt ? ' ' + txt.textContent.replace(/\u00a0/g, ' ') + '.' : ''));
        })
        .catch(function () {
          // on reste sur la page : nouvel essai automatique un peu plus tard (le bouton reste aussi cliquable)
          failures++;
          if (dir !== 'prev' && failures <= 3) setTimeout(onAutoScroll, 1500 * failures);
        })
        .then(function () {
          if (doc.contains(link)) {
            link.removeAttribute('aria-busy');
            link.classList.remove('is-loading');
          }
        });
    }

    /* ---------- "Afficher plus" dans un groupe de filtres ---------- */
    function moreLabel(btn, open) {
      btn.textContent = open ? tr('show_less') : tr('show_more', { n: btn.getAttribute('data-more-n') || '' });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function initMore(scope, expanded) {
      $$(scope, '[data-mp-filters-group]').forEach(function (g) {
        var btn = $(g, '[data-mp-filters-more]');
        if (!btn) return;
        var hasActive = $$(g, '.mp-filters__extra input:checked').length > 0;
        var open = !!((expanded && expanded[g.id]) || hasActive);
        g.classList.add('is-collapsible');
        g.classList.toggle('is-expanded', open);
        btn.hidden = false;
        moreLabel(btn, open);
      });
    }
    function toggleMore(btn) {
      var g = btn.closest('[data-mp-filters-group]');
      if (!g) return;
      var open = !g.classList.contains('is-expanded');
      var a = doc.activeElement;
      // on replie une liste qui contient le focus : il revient sur le bouton
      if (!open && a && a.closest && a.closest('.mp-filters__extra') && g.contains(a)) focusNoScroll(btn);
      g.classList.toggle('is-expanded', open);
      moreLabel(btn, open);
    }

    /* ---------- Tiroir (< 1200 px) ---------- */
    function goHome() {
      if (!panel || !home || !home.parentNode) return;
      if (drawerOpen()) return;
      if (panel.previousSibling !== home) home.parentNode.insertBefore(panel, home.nextSibling);
      panel.removeAttribute('aria-modal');
      if (panel.getAttribute('role') === 'dialog') panel.removeAttribute('role');
      if (WIDE.matches) panel.removeAttribute('aria-hidden');
    }
    function openDrawer(btn) {
      if (!panel || !MP.layer || isSidebar()) return;
      clearTimeout(backTimer);
      if (panel.parentNode !== doc.body) {
        (MP.portal || function (el) { doc.body.appendChild(el); })(panel);
        void panel.offsetWidth; // l'animation d'ouverture part de la position fermee
      }
      MP.layer.open(panel, btn, {
        onClose: function () {
          clearTimeout(backTimer);
          backTimer = setTimeout(goHome, 420);
        }
      });
    }

    /* ---------- Colonne de filtres (>= 1200 px) ---------- */
    function setHidden(on, save) {
      root.classList.toggle('is-filters-hidden', on);
      var btn = $(root, '[data-mp-filters-toggle]');
      if (btn) {
        btn.setAttribute('aria-expanded', on ? 'false' : 'true');
        var a = $(btn, '[data-mp-filters-hide]');
        var b = $(btn, '[data-mp-filters-show]');
        if (a) a.hidden = on;
        if (b) b.hidden = !on;
      }
      if (save) saveHidden(on);
    }
    function onWide() {
      if (WIDE.matches) {
        if (drawerOpen()) MP.layer.close({ silent: true });
        clearTimeout(backTimer);
        goHome();
        if (panel) panel.removeAttribute('aria-hidden');
      }
      // MP.layer met a jour aria-expanded de tous les boutons lies au panneau : on remet le bouton de la colonne d'accord
      setHidden(root.classList.contains('is-filters-hidden'), false);
    }

    /* ---------- Barre collante : filet quand elle est accrochee ---------- */
    function checkStuck() {
      stuckPending = false;
      if (!bar || !sentinel) return;
      var stickTop = parseFloat(window.getComputedStyle(bar).top) || 0;
      bar.classList.toggle('is-stuck', sentinel.getBoundingClientRect().top < stickTop - 0.5);
    }
    function onScroll() {
      if (stuckPending) return;
      stuckPending = true;
      raf(checkStuck);
    }

    /* ---------- Evenements ---------- */
    function onClick(e) {
      var t = e.target && e.target.closest ? e.target.closest('a, button') : null;
      if (!t) return;
      if (t.hasAttribute('data-mp-filters-more')) { e.preventDefault(); toggleMore(t); return; }
      if (t.hasAttribute('data-mp-filters-toggle')) {
        e.preventDefault();
        setHidden(!root.classList.contains('is-filters-hidden'), true);
        return;
      }
      if (t.hasAttribute('data-mp-filters-open')) { e.preventDefault(); openDrawer(t); focusGroup(t); return; }
      if (!plainClick(e)) return;
      if (t.hasAttribute('data-mp-filters-link')) {
        e.preventDefault();
        update(t.href, { scroll: true });
        return;
      }
      if (t.hasAttribute('data-mp-collection-next')) { e.preventDefault(); loadPage(t, 'next'); return; }
      if (t.hasAttribute('data-mp-collection-prev')) { e.preventDefault(); loadPage(t, 'prev'); }
    }
    // V1.12 barre facon Alo : un bouton de filtre ouvre le tiroir deplie sur son groupe (Size, Color, Price...)
    function focusGroup(btn) {
      var id = btn.getAttribute('data-mp-filters-focus');
      if (!id) return;
      setTimeout(function () {
        var g = doc.getElementById(id);
        if (!g) return;
        g.open = true;
        try { g.scrollIntoView({ block: 'start' }); } catch (err) {}
      }, 80);
    }
    function onKey(e) {
      // lien "Filtrer et trier" joue le role d'un bouton : Espace l'active aussi
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      var t = e.target && e.target.closest ? e.target.closest('[data-mp-filters-open]') : null;
      if (!t) return;
      e.preventDefault();
      openDrawer(t);
      focusGroup(t);
    }
    function onChange(e) {
      var t = e.target;
      if (!t || !t.name) return;
      // prix : a la validation (Entree ou sortie du champ) ; cases : petit delai pour grouper les clics rapides
      schedule(t.type === 'number' ? 0 : 250);
    }
    function onSubmit(e) {
      e.preventDefault();
      clearTimeout(timer);
      timer = null;
      var url = urlFromForm();
      if (url !== applied) update(url, { scroll: !drawerOpen() && isSidebar() });
      if (drawerOpen()) {
        MP.layer.close();
        setTimeout(toResults, 60);
      }
    }
    function onSort(e) {
      var v = e.target.value;
      var f = form();
      var radios = f ? $$(f, 'input[name="sort_by"]') : [];
      var hit = radios.filter(function (r) { return r.value === v; })[0];
      if (hit) {
        hit.checked = true;
        update(urlFromForm());
      } else {
        var u = new URL(window.location.href);
        u.searchParams.delete('page');
        if (v && v !== defaultSort) u.searchParams.set('sort_by', v);
        else u.searchParams.delete('sort_by');
        update(u.pathname + u.search);
      }
    }
    function onSortSubmit(e) {
      e.preventDefault();
      var sel = $(e.target, '[data-mp-filters-sort]');
      if (sel) onSort({ target: sel });
    }

    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKey);
    if (panel) {
      panel.addEventListener('click', function (e) {
        // le panneau peut etre dans body (tiroir) : ses clics ne remontent plus jusqu'a la section
        if (!root.contains(panel)) onClick(e);
      });
      var f = form();
      if (f) {
        f.addEventListener('change', onChange);
        f.addEventListener('submit', onSubmit);
      }
      initMore(panel, null);
    }
    var sortSel = $(root, '[data-mp-filters-sort]');
    if (sortSel) sortSel.addEventListener('change', onSort);
    var sortForm = $(root, '[data-mp-filters-sortform]');
    if (sortForm) sortForm.addEventListener('submit', onSortSubmit);

    root.querySelectorAll('[data-mp-filters-open]').forEach(function (b) { b.setAttribute('role', 'button'); });
    var toggleBtn = $(root, '[data-mp-filters-toggle]');
    if (toggleBtn) toggleBtn.hidden = false;
    setHidden(readHidden(), false);

    onMq(WIDE, onWide);
    if (bar && sentinel) {
      window.addEventListener('scroll', onScroll, { passive: true });
      checkStuck();
    }

    // V1.12 : la page suivante se charge toute seule quand on approche du bas de la grille (plus besoin de « Load more »)
    var autoTick = false;
    function autoMore() {
      autoTick = false;
      var l = $(root, '[data-mp-collection-next]');
      if (!l || l.getAttribute('aria-busy') === 'true') return;
      if (l.getBoundingClientRect().top < window.innerHeight + 700) loadPage(l, 'next');
    }
    function onAutoScroll() {
      if (autoTick) return;
      autoTick = true;
      (window.requestAnimationFrame || setTimeout)(autoMore);
    }
    window.addEventListener('scroll', onAutoScroll, { passive: true });

    root.__mpCol = {
      update: update,
      destroy: function () {
        offMq(WIDE, onWide);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('scroll', onAutoScroll);
        clearTimeout(timer);
        clearTimeout(backTimer);
        if (panel && !root.contains(panel)) {
          if (drawerOpen()) MP.layer.close({ silent: true });
          if (panel.parentNode) panel.parentNode.removeChild(panel);
        }
        root.__mpCol = null;
      }
    };
  }

  // puces de categories : la puce active est ramenee au centre de la ligne qui defile
  function centerChips(scope) {
    $$(scope || doc, '.mp-collection__cats').forEach(function (ul) {
      var on = $(ul, '.is-active');
      if (!on || ul.scrollWidth <= ul.clientWidth) return;
      ul.scrollLeft = Math.max(0, on.offsetLeft - (ul.clientWidth - on.offsetWidth) / 2);
    });
  }

  function boot(scope) {
    var list = $$(scope || doc, '[data-mp-collection]');
    if (scope && scope.matches && scope.matches('[data-mp-collection]')) list.unshift(scope);
    list.forEach(setup);
    centerChips(scope);
  }

  function start() {
    boot(doc);
    // editeur de theme
    doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    doc.addEventListener('shopify:section:unload', function (e) {
      $$(e.target, '[data-mp-collection]').forEach(function (r) { if (r.__mpCol) r.__mpCol.destroy(); });
    });
  }

  if (window.MP && MP.ready) MP.ready(start);
  else if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
